import type {
  GetListResponseOfHangfireJobSummary,
  HangfireJobDetailResponse,
  HangfireJobState,
  HangfireOverviewResponse,
  HangfireRecurringJobResponse,
  HangfireServerResponse,
} from 'src/api/ProactApiClient';
import {backgroundJobClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export interface HangfireJobsArgs {
  state: HangfireJobState;
  page: number;
  size: number;
  queue?: string;
}

export const backgroundJobApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getHangfireOverview: builder.query<HangfireOverviewResponse, void>({
      queryFn: clientQuery(() => backgroundJobClient.hangfireOverview()),
      providesTags: ['HangfireJobs'],
    }),
    getHangfireServers: builder.query<HangfireServerResponse[], void>({
      queryFn: clientQuery(() => backgroundJobClient.hangfireServers()),
      providesTags: ['HangfireJobs'],
    }),
    getHangfireJobs: builder.query<
      GetListResponseOfHangfireJobSummary,
      HangfireJobsArgs
    >({
      queryFn: clientQuery(({state, page, size, queue}) =>
        backgroundJobClient.hangfireJobs(state, page, size, queue)
      ),
      providesTags: ['HangfireJobs'],
    }),
    getHangfireJobDetail: builder.query<HangfireJobDetailResponse, string>({
      queryFn: clientQuery(id => backgroundJobClient.hangfireJobDetail(id)),
      providesTags: ['HangfireJobs'],
    }),
    getHangfireRecurringJobs: builder.query<
      HangfireRecurringJobResponse[],
      void
    >({
      queryFn: clientQuery(() => backgroundJobClient.hangfireRecurring()),
      providesTags: ['HangfireRecurringJobs'],
    }),
    requeueHangfireJob: builder.mutation<void, string>({
      queryFn: voidClientQuery(id => backgroundJobClient.hangfireRequeue(id)),
      invalidatesTags: ['HangfireJobs'],
    }),
    deleteHangfireJob: builder.mutation<void, string>({
      queryFn: voidClientQuery(id => backgroundJobClient.hangfireDelete(id)),
      invalidatesTags: ['HangfireJobs'],
    }),
    triggerHangfireRecurringJob: builder.mutation<void, string>({
      queryFn: voidClientQuery(id => backgroundJobClient.hangfireTrigger(id)),
      invalidatesTags: ['HangfireJobs', 'HangfireRecurringJobs'],
    }),
  }),
});

export const {
  useGetHangfireOverviewQuery,
  useGetHangfireServersQuery,
  useGetHangfireJobsQuery,
  useGetHangfireJobDetailQuery,
  useGetHangfireRecurringJobsQuery,
  useRequeueHangfireJobMutation,
  useDeleteHangfireJobMutation,
  useTriggerHangfireRecurringJobMutation,
} = backgroundJobApi;
